import { FileRef } from 'types';
import fetch from 'utils/fetch';

const fileUrl = '/api/file';

export async function uploadFile(file: File) {
  const formData = new FormData();

  formData.append('file', file, file.name);

  const response = await fetch(`${fileUrl}`, {
    method: 'POST',
    body: formData,
  });

  const fileRef: FileRef = await response.json();
  return fileRef;
}

export const deleteFile = async (id: string) =>
  await fetch(`${fileUrl}/${id}`, {
    method: 'DELETE',
  });
